import './Icon/Icon.scss';
import './Button/Button.scss';
import './Button/CopyButton.scss';
import './ContactData/ContactData.scss';
import './Calendar/Calendar.scss';
import './Text/';
import './LeadInText/LeadInText.scss';
import './Heading/Heading.scss';
import './HorizontalRule/HorizontalRule.scss';
import './Image/Image.scss';
import './Listing/Listing.scss';
import './Download/List.scss';
import './TeamMember/InfoBox.scss';
import './TeamMember/ListItem.scss';
import './Table/';
import './Card/';
import './Video/';
import './Columns/TwoCol.scss';
import { Accordion } from './Accordion';
import { forAll } from '@ofm/util';

if (document.body.className.indexOf('neos-backend') < 0) {
    document.addEventListener('DOMContentLoaded', () => {
        forAll('.js-accordion', e => new Accordion(e, 'accordion'));
    });
}
